module.exports = __webpack_public_path__ + "static/media/curlegance-2.f8784b48.jpg";